import { Navigate, Route, Routes } from "react-router-dom";

import { AdminPage } from "../features/admin/AdminPage";
import { AuthGate } from "../features/auth/AuthGate";
import { DashboardPage } from "../features/dashboard/DashboardPage";
import { RegisterPage } from "../features/register/RegisterPage";
import { SharePage } from "../features/share/SharePage";
import { ParentReportPage } from "../features/parent/ParentReportPage";

export function App() {
  return (
    <Routes>
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/register.html" element={<RegisterPage />} />
      <Route path="/admin" element={<AuthGate><AdminPage /></AuthGate>} />
      <Route path="/admin.html" element={<AuthGate><AdminPage /></AuthGate>} />
      <Route path="/share" element={<SharePage />} />
      <Route path="/share.html" element={<SharePage />} />
      <Route path="/assets/share.html" element={<SharePage />} />
      <Route path="/parent-report/:token" element={<ParentReportPage />} />
      <Route
        path="/*"
        element={
          <AuthGate>
            <DashboardPage />
          </AuthGate>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
